"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assetFolderDeleteFetchApi = assetFolderDeleteFetchApi;
exports.assetFolderDeleteHardDeleteBulkApi = assetFolderDeleteHardDeleteBulkApi;
exports.assetFolderDeleteRestoreApi = assetFolderDeleteRestoreApi;
exports.assetFolderDeleteRetoreBulkApi = assetFolderDeleteRetoreBulkApi;
exports.assetFolderDeleteSoftDeleteApi = assetFolderDeleteSoftDeleteApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * hard delete bulk
 * @param payload
 * @returns api response
 * @description this function used to hard delete bulk asset.
 */
function assetFolderDeleteHardDeleteBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.AssetsService.assetFolderDelete.hardDeleteBulk), params);
}

/**
 * restore bulk
 * @param payload
 * @returns api response
 * @description this function used to restore bulk asset.
 */
function assetFolderDeleteRetoreBulkApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.AssetsService.assetFolderDelete.restoreBulk), params);
}

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to fetch asset.
 */
function assetFolderDeleteFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.AssetsService.assetFolderDelete.fetch), params);
}

/**
 * restore
 * @param payload
 * @returns api response
 * @description this function used to restore asset.
 */
function assetFolderDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.AssetsService.assetFolderDelete.restore), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete asset.
 */
function assetFolderDeleteSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.AssetsService.assetFolderDelete.softdelete), params);
}